import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { Review } from '@app/core/interfaces';
import { ProductIdNameService } from '@app/core/services/product-id-name.service';
import * as favoriteReviewsActions from '@app/store/actions/favorite_reviews.actions';
import * as fromRoot from '@app/store/app.reducer';
import { ReviewsService } from '@app/store/effects/reviews.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'ins-reviews-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container *ngIf="isBrowser && reviews$ | async">
            <ins-reviews [reviews]="reviews$ | async"
                         [itemsInView]="itemsInView"
                         [showControls]="showControls"></ins-reviews>
        </ng-container>
    `,
})
export class ReviewsContainer implements OnInit {
    @Input() reviewId: ReviewIdEnum = ReviewIdEnum.InShared;
    @Input() itemsInView: number;
    @Input() showControls: boolean = true;

    public isBrowser: boolean = isPlatformBrowser(this.platformId);
    public readonly reviews$: Observable<Review[]> = this.reviewsService.fav_reviews$;

    constructor(
        private store: Store<fromRoot.State>,
        private reviewsService: ReviewsService,
        @Inject(PLATFORM_ID) public platformId: Object,
    ) {
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            const productId = ProductIdNameService.getProductNameByReviewId(this.reviewId);

            this.store.dispatch(new favoriteReviewsActions.SetSelectedFavoriteProductName({product_id: productId}));
            this.store.dispatch(new favoriteReviewsActions.NeedSelectedFavoriteProduct({product_id: productId}));
        }
    }

}
